export const QUESTION = {
  SINGULAR: 'metric',
  CAPITALIZED_SINGULAR: 'Metric',
  PLURAL: 'metrics',
  CAPITALIZED_PLURAL: 'Metrics',
  UPPERCASE_PLURAL: 'METRICS'
}